<template>
  <div class="headline">
    <v-chip v-if="chipText" class="text-chip" :class="(chipColor ? `${chipColor}-chip` : 'blue-chip')">{{ chipText }}</v-chip>
    <h2 v-if="titleText" class="title">{{ titleText }}</h2>
    <h4 v-if="subtitleText" class="subtitle">{{ subtitleText }}</h4>
  </div>
</template>

<script setup lang="ts">
import { VChip } from 'vuetify/components';
defineProps<{
  chipText?: string,
  chipColor?: string,
  titleText?: string,
  subtitleText?: string,
}>();
</script>

<style scoped lang="scss"></style>